<template>

    <!-- 说明详细信息 并且可以复制 -->
    <el-dialog v-if="infoDialog" title="详细说明" :visible.sync="infoDialog" append-to-body width="60%" min-height="500px" top="5vh">
        <json-editor ref="jsonEditor" v-model="jsontext" />
    </el-dialog>
    
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
export default {
    components: {JsonEditor},
    data() {
        return {
            jsontext: null,
            infoDialog: false
        }
    },

    methods: {
        init(row) {
            this.jsontext = ''
            this.infoDialog = true

            this.$nextTick(() => {
               
                this.jsontext = row
                
            })
        }
    }
}
</script>